import { render } from "./ReferensiPendaftaranModal.vue?vue&type=template&id=57199edc&scoped=true"
import script from "./ReferensiPendaftaranModal.vue?vue&type=script&lang=js"
export * from "./ReferensiPendaftaranModal.vue?vue&type=script&lang=js"

import "./ReferensiPendaftaranModal.vue?vue&type=style&index=0&id=57199edc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57199edc"]])

export default __exports__